// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"6162efee","404":"8347e9f8","496":"4b201b41","498":"5dfab362"}[chunkId] + ".chunk.js";
};